import axios from "axios";

class AuthService {
  constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_SERVER_URL || "https://fundeia.pt/server",
    });

    // Automatically set JWT token on the request headers for every request
    this.api.interceptors.request.use((config) => {
      // Retrieve the JWT token from the local storage
      const storedToken = localStorage.getItem("authToken");

      if (storedToken) {
        config.headers = { Authorization: `Bearer ${storedToken}` };
      }

      return config;
    });
  }

  login = (requestBody) => {
    return this.api.post("/auth/login", requestBody);
    // same as
    // return axios.post("https://fundeia.pt/server/auth/login");
  };

  forgotPasswordOTP = (requestBody) => {
    return this.api.post("/auth/forgotPasswordOTP", requestBody);
    // same as
    // return axios.post("https://fundeia.pt/server/auth/forgotPasswordOTP");
  };

  resetPassword = (requestBody) => {
    return this.api.patch("/auth/resetPassword", requestBody);

  };

  sendOTP = (requestBody) => {
    return this.api.post("/auth/sendOTP", requestBody);
    // same as
    // return axios.post("https://fundeia.pt/server/auth/sendOTP");
  };

  signup = (requestBody) => {
    return this.api.post("/auth/signup", requestBody);
    // same as
    // return axios.post("https://fundeia.pt/server/auth/singup");
  };

  verify = () => {
    return this.api.get("/auth/verify");
    // same as
    // return axios.post("https://fundeia.pt/server/auth/verify");
  };
}

// Create one instance (object) of the service
const authService = new AuthService();

export default authService;
